import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { transferUserDataFormAction } from "../../redux/rootReducer";
import { TRANSFER_USER_DATA_FORM_INITIAL } from "../../redux/initialStateConstant";
import { transferUserDataSagaAction } from "../../redux/sagaActions";

const UserTransferForm = () => {
    const dispatch = useDispatch();
    const transferUserDataForm = useSelector(state => state.transferUserDataForm);


    if (!transferUserDataForm.open) return false;

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close" onClick={ () => dispatch(transferUserDataFormAction(TRANSFER_USER_DATA_FORM_INITIAL)) }/>
                        <div className="form__title">Перенос данных</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Номер телефона с которого перенести данные</div>
                        <input type="text" className="input" autoFocus value={ transferUserDataForm.wrongPhone } onInput={ event => dispatch(transferUserDataFormAction({
                            ...transferUserDataForm,
                            wrongPhone: event.target.value
                        })) } />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Номер телефона куда перенести данные</div>
                        <input type="text" className="input" value={ transferUserDataForm.correctPhone } onInput={ event => dispatch(transferUserDataFormAction({
                            ...transferUserDataForm,
                            correctPhone: event.target.value
                        })) } />
                    </div>
                    <div className="form__field">
                        <div className="button"
                             onClick={ () => {
                                 if (window.confirm('Вы действительно хотите перенести данные? После выполнения операции, посетитель с которого переносятся данные будет удалён.')) {
                                     dispatch(transferUserDataSagaAction({
                                         wrongPhone: transferUserDataForm.wrongPhone,
                                         correctPhone: transferUserDataForm.correctPhone
                                     }))
                                 }
                             } }
                        >Перенести данные</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserTransferForm;